import React from "react";
import { Link } from "react-router-dom";
// Bilder
import RENOVIERUNG from "../assets/renovierung.jpeg";
import TROCKENBAU from "../assets/trockenbau.jpeg";
import BODEN from "../assets/bodenleger.jpeg";
import MALEREI from "../assets/malerei.jpg"
import FLIESENLEGER from "../assets/fliesenleger.jpg"
import HINTERGRUND from "../assets/hintergrund_services.jpg"

const Services: React.FC = () => {
  return (
<div className="bg-gray-100 text-gray-800 min-h-screen flex flex-col">
    {/* ================= HERO SECTION ================= */}
    <section
      className="relative flex items-center justify-center text-center
                h-[50vh] md:h-[60vh] sm:h-[40vh]"
      style={{
        backgroundImage: `url(${HINTERGRUND})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
    {/* Dunkles Overlay */}
    <div className="absolute inset-0 bg-black/50" />

    <div className="relative max-w-6xl mx-auto px-4 sm:px-6 py-20 md:py-28 text-center text-white">

        <h1 className="text-3xl md:text-4xl font-bold mb-4">
        Unsere Dienstleistungen
        </h1>

        <p className="max-w-2xl mx-auto mb-8 text-sm md:text-base text-gray-200">
            Mit handwerklicher Erfahrung, hochwertigen Materialien und einem klaren Blick für Details realisieren wir nachhaltige Lösungen für Ihre Immobilie.
        </p>
    </div>
    </section>

    <div className="bg-gray-100 min-h-screen py-16">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 space-y-10">
        {/* ================= LEISTUNG 1 ================= */}
        <div className="
          group flex flex-col md:flex-row
          bg-gray-200
          rounded-xl overflow-hidden
          transition-all duration-300
          hover:bg-white hover:shadow-lg
        ">
          <img
            src={RENOVIERUNG}
            alt="Schlüsselfertige Renovierung"
            className="
              w-full md:w-1/3 h-56 md:h-auto
              object-cover
              grayscale group-hover:grayscale-0
              transition-all duration-300
            "
          />

          <div className="flex items-center justify-center p-8 text-center md:text-left">
            <div>
              <h2 className="text-2xl font-bold mb-4">
                Schlüsselfertige Renovierung
              </h2>
              <p className="text-gray-600">
                Wir bieten umfassende Renovierungsarbeiten für Wohn- und Geschäftsbereiche an und begleiten Sie von der ersten Planung bis zur finalen Umsetzung. Dabei legen wir großen Wert auf saubere Ausführung, Termintreue und hochwertige Materialien. Ob Teil- oder Komplettsanierung – wir modernisieren Räume, verbessern die Funktionalität und steigern nachhaltig den Wert Ihrer Immobilie. Durch unsere Erfahrung und sorgfältige Arbeitsweise sorgen wir für Ergebnisse, die sowohl optisch als auch technisch überzeugen.
              </p>
            </div>
          </div>
        </div>

        {/* ================= LEISTUNG 2 ================= */}
        <div className="
          group flex flex-col md:flex-row
          bg-gray-200
          rounded-xl overflow-hidden
          transition-all duration-300
          hover:bg-white hover:shadow-lg
        ">
          <img
            src={TROCKENBAU}
            alt="Trockenbau"
            className="
              w-full md:w-1/3 h-56 md:h-auto
              object-cover
              grayscale group-hover:grayscale-0
              transition-all duration-300
            "
          />

          <div className="flex items-center justify-center p-8 text-center md:text-left">
            <div>
              <h2 className="text-2xl font-bold mb-4">
                Trockenbau
              </h2>
              <p className="text-gray-600">
                Im Bereich Trockenbau realisieren wir flexible und moderne Raumlösungen, die sich optimal an Ihre Bedürfnisse anpassen. Wir errichten Trennwände, abgehängte Decken sowie individuelle Sonderkonstruktionen und achten dabei auf Stabilität, Schallschutz und Energieeffizienz. Dank präziser Planung und sauberer Montage entstehen funktionale Räume mit klaren Linien und hoher Qualität – ideal für Wohnräume, Büros oder Gewerbeflächen.
              </p>
            </div>
          </div>
        </div>

        {/* ================= LEISTUNG 3 ================= */}
        <div className="
          group flex flex-col md:flex-row
          bg-gray-200
          rounded-xl overflow-hidden
          transition-all duration-300
          hover:bg-white hover:shadow-lg
        ">
          <img
            src={BODEN}
            alt="Bodenleger"
            className="
              w-full md:w-1/3 h-56 md:h-auto
              object-cover
              grayscale group-hover:grayscale-0
              transition-all duration-300
            "
          />

          <div className="flex items-center justify-center p-8 text-center md:text-left">
            <div>
              <h2 className="text-2xl font-bold mb-4">
                Bodenleger
              </h2>
              <p className="text-gray-600">
                Ein hochwertiger Boden ist die Basis für ein angenehmes Raumgefühl. Wir verlegen Parkett, Laminat, Vinyl, Teppich sowie weitere Bodenbeläge fachgerecht und präzise. Dabei achten wir auf eine sorgfältige Untergrundvorbereitung, exakte Verarbeitung und eine langlebige Ausführung. Unser Ziel ist ein Boden, der nicht nur optisch überzeugt, sondern auch den täglichen Anforderungen standhält und langfristig Freude bereitet.
              </p>
            </div>
          </div>
        </div>

        {/* ================= LEISTUNG 4 ================= */}
        <div className="
          group flex flex-col md:flex-row
          bg-gray-200
          rounded-xl overflow-hidden
          transition-all duration-300
          hover:bg-white hover:shadow-lg
        ">
          <img
            src={MALEREI}
            alt="Malerei"
            className="
              w-full md:w-1/3 h-56 md:h-auto
              object-cover
              grayscale group-hover:grayscale-0
              transition-all duration-300
            "
          />

          <div className="flex items-center justify-center p-8 text-center md:text-left">
            <div>
              <h2 className="text-2xl font-bold mb-4">
                Malerei
              </h2>
              <p className="text-gray-600">
                Mit professionellen Malerarbeiten verleihen wir Räumen neuen Charakter und frische Ausstrahlung. Ob Innen- oder Außenbereiche – wir führen Anstriche, Lackierungen und Spachtelarbeiten sauber und detailgenau aus. Dabei setzen wir auf hochwertige Farben, moderne Techniken und eine sorgfältige Vorbereitung der Oberflächen. So entstehen gleichmäßige, langlebige Ergebnisse, die Räume aufwerten und ein angenehmes Wohn- oder Arbeitsklima schaffen.
              </p>
            </div>
          </div>
        </div>

        {/* ================= LEISTUNG 5 ================= */}
        <div className="
          group flex flex-col md:flex-row
          bg-gray-200
          rounded-xl overflow-hidden
          transition-all duration-300
          hover:bg-white hover:shadow-lg
        ">
          <img
            src={FLIESENLEGER}
            alt="Fliesenleger"
            className="
              w-full md:w-1/3 h-56 md:h-auto
              object-cover
              grayscale group-hover:grayscale-0
              transition-all duration-300
            "
          />

          <div className="flex items-center justify-center p-8 text-center md:text-left">
            <div>
              <h2 className="text-2xl font-bold mb-4">
                Fliesenleger
              </h2>
              <p className="text-gray-600">
                Unsere Fliesenarbeiten verbinden Funktionalität mit ästhetischem Anspruch. Wir verlegen Wand- und Bodenfliesen in Bädern, Küchen, Wohnräumen sowie im Außenbereich. Durch präzise Ausrichtung, saubere Fugen und hochwertige Materialien entstehen langlebige und pflegeleichte Flächen. Ob klassisch, modern oder individuell – wir setzen Ihre Vorstellungen fachgerecht um und sorgen für ein harmonisches Gesamtbild.
              </p>
            </div>
          </div>
        </div>
        <div className="
          mt-6
          flex flex-col sm:flex-row
          gap-4
          justify-center md:justify-start
        ">
          {/* Primärer CTA */}
          <Link
            to="/contact"
            className="
              bg-red-600 text-white
              px-6 py-3
              rounded-lg
              font-semibold
              text-center
              hover:bg-red-700
              transition
            "
          >
            Kostenlose Renovierungsberatung anfragen
          </Link>

          {/* Anrufen Button */}
          <a
            href="tel:+4917657122695"
            className="
              border-2 border-red-600
              text-red-600
              px-6 py-3
              rounded-lg
              font-semibold
              text-center
              hover:bg-red-600 hover:text-white
              transition
            "
          >
            Anrufen
          </a>
        </div>

        </div>

      </div>
    </div>
  );
};

export default Services;
